<script>
    export let props = {
        range: 100,
        visible: true
    };

    function moveSlider(e) {
        const slider = e.srcElement.parentElement.parentElement.querySelector('div');
        slider.scroll((slider.scrollLeft + props.range), 0);
    }
</script>

{#if props.visible}
    <div class="box-mover">
        <div class="arrow">
            <i class="fas fa-chevron-right"></i>
            <div on:click={moveSlider} class="click"></div>
        </div>
    </div>
{/if}

<style type="text/scss">
    .box-mover {
        .arrow {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 30px;
            background: white;
            border-radius: 100%;
            position: absolute;
            z-index: 100;
            top: 50%;
            right: 20px;
            cursor: pointer;
        }

        .click {
            position: absolute;
            z-index: 15000;
            background: transparent;
            width: 100%;
            height: 100%;
        }
    }
</style>